export type IInitTooltips = IDCA.IGenericFunc;

export function _initTooltips(): void {
  $('form .tooltips').each((_, elm) => {
    $(elm).tooltip({ container: 'body' });
  });
}
